module.exports = __webpack_public_path__ + "static/cc-logo-982c531432c4ad7e8dbf3cf52a1dc6d0.png";